import React from 'react';
import useDateFormat from "common/hooks/useDateFormat";

export default function DateLabel({ timestamp }) {
  const dateFormat = useDateFormat();


  if (timestamp) {
    const convertedTimestamp = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
    return <>{dateFormat.format(convertedTimestamp)}</>;
  } else {
    return null;
  }
}
